<div class="logo">
    @if (!staticLogo) {
        <a class="a--border-off" href="/" [routerLink]="routeEntity.Root">
            <img [ngClass]="additionalLogoImgClass" [attr.src]="" [attr.alt]="altText" />
        </a>
    } @else {
        <img [ngClass]="additionalLogoImgClass" [attr.src]="" [attr.alt]="altText" />
    }
</div>
